import { ArticleParameter, KeyField_Type } from "../../../../api/schema";
import { FloatField } from "./FloatField";
import { SelectField } from "./SelectField";
import { StringField } from "./StringField";

interface ArticleParameterRowProps {
  field: ArticleParameter;
  on_changed: () => void;
}

export const ArticleParameterRow = (props: ArticleParameterRowProps) => {
  switch (props.field.key_field.type) {
    case KeyField_Type.float:
      return (
        <FloatField parameter={props.field} on_changed={props.on_changed} />
      );
    case KeyField_Type.select:
      return (
        <SelectField parameter={props.field} on_changed={props.on_changed} />
      );
    case KeyField_Type.text:
      return (
        <StringField parameter={props.field} on_changed={props.on_changed} />
      );
  }
};
